module.exports = __webpack_public_path__ + "img/rejected-semipublic.a6b25f3b.png";